import { defineMessages } from 'react-intl';

const messages = defineMessages({
  voucherDetails: {
    id: 'manageHudVoucherDetails.voucherDetails',
    defaultMessage: 'Voucher Details',
  },
  scheduledForTracsSubmission: {
    id: 'manageHudVoucherDetails.scheduledForTracsSubmission',
    defaultMessage: '{count} Scheduled for TRACS Submission',
  },
  voucherSubmittedToTracsNote: {
    id: 'manageHudVoucherDetails.voucherSubmittedToTracsNote',
    defaultMessage:
      'Voucher submitted to TRACS. You can manage the TRACS Status from Manage HUD Vouchers.',
  },
  adjustments: {
    id: 'manageHudVoucherDetails.adjustments',
    defaultMessage: 'Adjustments',
  },
  moveToNextVoucherSuccessTitle: {
    id: 'manageHudVoucherDetails.moveToNextVoucherSuccessTitle',
    defaultMessage: 'Success',
  },
  moveToNextVoucherSuccessMessage: {
    id: 'manageHudVoucherDetails.moveToNextVoucherSuccessMessage',
    defaultMessage: 'New Tenant Event has been moved to the next voucher.',
  },
  voucherStatusUpdatedTitle: {
    id: 'manageHudVoucherDetails.voucherStatusUpdatedTitle',
    defaultMessage: 'Voucher Status Updated',
  },
  voucherReturnedToDraftWarning: {
    id: 'manageHudVoucherDetails.voucherReturnedToDraftWarning',
    defaultMessage:
      'The voucher has been returned to Draft status. A new submission will be required.',
  },
  undoSubmittedChangesConfirmationTitle: {
    id: 'manageHudVoucherDetails.undoSubmittedChangesConfirmationTitle',
    defaultMessage: 'Undo Changes & Restore Voucher?',
  },
  undoSubmittedChangesConfirmationBody: {
    id: 'manageHudVoucherDetails.undoSubmittedChangesConfirmationBody',
    defaultMessage:
      'Are you sure you want to undo the changes that were made on this Voucher after initial submission? ' +
      'This will restore it back to its previous Submitted status and version.',
  },
  cancel: {
    id: 'manageHudVoucherDetails.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'manageHudVoucherDetails.confirm',
    defaultMessage: 'Confirm',
  },
  undoSubmittedChangesSuccessTitle: {
    id: 'manageHudVoucherDetails.undoSubmittedChangesSuccessTitle',
    defaultMessage: 'Changes Undone',
  },
  undoSubmittedChangesSuccessBody: {
    id: 'manageHudVoucherDetails.undoSubmittedChangesSuccessBody',
    defaultMessage: 'The voucher was restored to its latest submitted version.',
  },
  rapAdjustmentsGatingBanner: {
    id: 'manageHudVoucherDetails.rapAdjustmentsGatingBanner',
    defaultMessage:
      'New Tenant Events must be submitted to TRACS before data for your Voucher will populate here.',
  },
  unitsLabel: {
    id: 'manageHudVoucherDetails.unitsLabel',
    defaultMessage: '# of Units',
  },
  requestedLabel: {
    id: 'manageHudVoucherDetails.requestedLabel',
    defaultMessage: 'Requested',
  },
  approvedLabel: {
    id: 'manageHudVoucherDetails.approvedLabel',
    defaultMessage: 'Approved',
  },
  caHudApprovedLabel: {
    id: 'manageHudVoucherDetails.caHudApprovedLabel',
    defaultMessage: 'CA/HUD Approved',
  },
  varianceLabel: {
    id: 'manageHudVoucherDetails.varianceLabel',
    defaultMessage: 'Variance',
  },
  totalRequestedLabel: {
    id: 'manageHudVoucherDetails.totalRequestedLabel',
    defaultMessage: 'Total Requested',
  },
  totalCaHudApprovedLabel: {
    id: 'manageHudVoucherDetails.totalCaHudApprovedLabel',
    defaultMessage: 'Total CA/HUD Approved',
  },
  updateApprovedAmountSuccess: {
    id: 'manageHudVoucherDetails.updateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
  updateApprovedAmountError: {
    id: 'manageHudVoucherDetails.updateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
  updateApprovedAmountMissingIdError: {
    id: 'manageHudVoucherDetails.updateApprovedAmountMissingIdError',
    defaultMessage: 'Unable to update approved amount. Record ID is missing.',
  },
  regularAssistanceDeriveSuccess: {
    id: 'manageHudVoucherDetails.regularAssistanceDeriveSuccess',
    defaultMessage: 'Regular Assistance was refreshed.',
  },
  regularAssistanceDeriveError: {
    id: 'manageHudVoucherDetails.regularAssistanceDeriveError',
    defaultMessage: 'Failed to refresh Regular Assistance. Please try again.',
  },
  downloading50059: {
    id: 'manageHudVoucherDetails.downloading50059',
    defaultMessage: 'Downloading 50059 certification...',
  },
  downloading50059a: {
    id: 'manageHudVoucherDetails.downloading50059a',
    defaultMessage: 'Downloading 50059a certification...',
  },
  downloading50059Error: {
    id: 'manageHudVoucherDetails.downloading50059Error',
    defaultMessage: 'Failed to download certification.',
  },
  noPermissionTooltip: {
    id: 'manageHudVoucherDetails.noPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
});

export default messages;
